<template>
    <div
      style=""
      class="pt-5 px-5"
    >
        <div class="row">
            <div class="col-lg-6">
                <h2>Raising children is hard</h2>
            </div>
            <div class="col-lg-6">
                <div
                    style="overflow:auto;-webkit-overflow-scrolling:touch;"
                    class="center"
                >
                    <!-- <script src="https://agency.enginehire.io/src/assets/js/embedded_script.js"></script> -->
                    <iframe
                    style="border: none;"
                    id="enginehire-iframe"
                    src="https://needumom.enginehire.io/application-form/177/3676"
                    width="100%"
                    height="1800"
                    data-hj-allow-iframe
                    ></iframe>
                </div>
            </div>
        
        <!-- <h3>Want more info?</h3> -->
          <!-- <h5>hello@enginehire.ca | 1.855.775.4473</h5> -->
          
        </div>
    </div>
  </template>

<script>
export default {
  created() {
    // this.$store.dispatch('tryAutoLogin')
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Families.vue